import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OrderContext = createContext(null);

export const OrderProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [preselectedPack, setPreselectedPack] = useState(null);
  const [inventory, setInventory] = useState({ items: [], all_sold_out: false, drop_id: null });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/menu`);
      // Normalise: pause or all-slots-full behaves like sold-out on the public site
      const merged = {
        ...data,
        all_sold_out: !!(data.all_sold_out || data.paused || data.all_slots_full),
      };
      setInventory(merged);
    } catch (e) {
      // network errors handled silently — UI shows current state
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  const openWith = (pack) => {
    setPreselectedPack(pack || null);
    setOpen(true);
  };

  return (
    <OrderContext.Provider
      value={{ open, setOpen, preselectedPack, setPreselectedPack, openWith, inventory, refreshInventory: refresh, loadingInventory: loading }}
    >
      {children}
    </OrderContext.Provider>
  );
};

export const useOrder = () => {
  const ctx = useContext(OrderContext);
  if (!ctx) throw new Error("useOrder must be used inside OrderProvider");
  return ctx;
};
